import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Card, IconButton, Dialog, TextField, Button, Typography } from '@totalsoft/rocket-ui';
import Comment from '@mui/icons-material/Comment';
import Edit from '@mui/icons-material/Edit';
import Delete from '@mui/icons-material/DeleteForever';
import { get, set } from '@totalsoft/react-state-lens';
import { RightsContext } from 'providers/RightsContext';

const FolderCommentComponent = ({ commentLens, deleteComment, index, onSaveItem, saving }) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const comment = commentLens |> get;
  const { readOnlyFull, riskAssesmentNotesWrite } = useContext(RightsContext);

  return (
    <React.Fragment>
      <Card
        title={
          <Grid container spacing={1}>
            <Grid item>
              <Comment />
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                <strong>{comment.userName}</strong>
                {comment.edited
                  ? t('Folder.RiskComments.AddedOn') + t('LONG_DATE', { date: comment.commentDate }) + t('Folder.RiskComments.Edited')
                  : t('Folder.RiskComments.AddedOn') + t('LONG_DATE', { date: comment.commentDate })}
              </Typography>
            </Grid>
          </Grid>
        }
        actions={
          <React.Fragment>
            {riskAssesmentNotesWrite && (
              <IconButton
                id={'offerNotes_comment_' + index + '_deleteBtn'}
                onClick={() => {
                  setDialogOpen(true);
                }}
                title={t('Document.Comments.Delete')}
                disabled={!comment.canDelete || readOnlyFull || saving}
                color='primary'
                variant='text'
              >
                <Delete />
              </IconButton>
            )}
            <IconButton
              id={'offerNotes_comment_' + index + '_editBtn'}
              onClick={() => {
                setEditing(true);
              }}
              title={t('Document.Comments.Edit')}
              disabled={!comment.canEdit || readOnlyFull || saving}
              color='primary'
              variant='text'
            >
              <Edit />
            </IconButton>
          </React.Fragment>
        }
      >
        {editing ? (
          <Grid>
            <TextField
              id={'offerNotes_comment_' + index + '_text'}
              multiline
              maxRows='5'
              fullWidth
              value={comment.freeTxt}
              name='freeTxt'
              onChange={value => {
                (commentLens.freeTxt |> set)(value);
              }}
              inputProps={{
                maxLength: 8000
              }}
            />
            <Button
              id={'offerNotes_comment_' + index + '_saveBtn'}
              disabled={saving}
              onClick={() => {
                onSaveItem({ ...comment, edited: true }, comment.freeTxt);
                setEditing(false);
              }}
              color='primary'
              sx={{ marginTop: 1 }}
            >
              {saving ? t('Saving') : t('Save')}
            </Button>
          </Grid>
        ) : (
          <Typography>{comment.freeTxt}</Typography>
        )}

        {riskAssesmentNotesWrite && (
          <React.Fragment>
            <Dialog
              open={dialogOpen}
              onClose={() => {
                setDialogOpen(false);
              }}
              maxWidth='xs'
              aria-labelledby='alert-dialog-title'
              aria-describedby='alert-dialog-description'
              title={t('Document.Comments.Dialog.Title')}
              content={t('Document.Comments.Dialog.Description')}
              actions={
                <>
                  <Button
                    id={'offerNotes_comment_dialog_acceptBtn'}
                    color='primary'
                    autoFocus
                    onClick={() => {
                      deleteComment();
                      setDialogOpen(false);
                    }}
                  >
                    {t('Document.Comments.Dialog.AcceptButton')}
                  </Button>
                  <Button
                    id={'offerNotes_comment_dialog_rejectBtn'}
                    color='primary'
                    onClick={() => {
                      setDialogOpen(false);
                    }}
                  >
                    {t('Document.Comments.Dialog.RejectButton')}
                  </Button>
                </>
              }
            />
          </React.Fragment>
        )}
      </Card>
    </React.Fragment>
  );
};

FolderCommentComponent.propTypes = {
  commentLens: PropTypes.object.isRequired,
  deleteComment: PropTypes.func.isRequired,
  index: PropTypes.number,
  setCurrentComment: PropTypes.func,
  onSaveItem: PropTypes.func,
  onPropertyChange: PropTypes.func,
  saving: PropTypes.bool
};

export default FolderCommentComponent;
